import { useLocation, useNavigate } from 'react-router-dom';

// React Router gives location.key the literal string "default" only on the
// initial history entry (deep link, refresh, new tab). After any in-app
// navigation it becomes a random hash. Using it lets us call navigate(-1)
// when safe and fall back to an explicit route when going back would leave
// the app. See https://github.com/remix-run/react-router/discussions/9922
export const useBackNavigate = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (fallback: string) => {
    if (location.key === 'default') {
      navigate(fallback, { replace: true });
    } else {
      navigate(-1);
    }
  };
};
